export default function(state=null, action) {

    switch(action.type) {
        case "USERID":
            return action.payload;

        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/ReducerUserId.js